<template>
    <div>
        <div style="display: flex; flex-direction: column;">
            <div class="profile-create-form-section-title">Profile Information</div>
            <div class="profile-input-field">
                <app-text-field
                    v-model="form.profileId"
                    label="Profile ID*"
                    error-label="Profile ID"
                    type="number"
                    rules="required|positive"
                    row
                />
            </div>
            <div class="profile-input-field">
                <app-text-field
                    v-model="form.firstName"
                    label="First Name*"
                    error-label="First Name"
                    rules="required|max:50"
                    row
                />
            </div>
            <div class="profile-input-field">
                <app-text-field
                    v-model="form.lastName"
                    label="Last Name*"
                    error-label="Last Name"
                    rules="required|max:50"
                    row
                />
            </div>
            <div class="profile-input-field">
                <app-form-date-picker
                    row
                    v-model="form.birthDate"
                    label="Birth Date*"
                    mask="##/##/####"
                    placeholder="MM/DD/YYYY"
                    :max="today"
                    start-with-year
                />
            </div>

            <div v-if="includeGroups" class="profile-input-field">
                <div class="profile-create-form-section-title">Select Groups</div>
                <app-form-multiple-select
                    v-if="groups"
                    v-model="form.groupIds"
                    :items="groups"
                    rules="required"
                    item-text="name"
                    item-value="id"
                    label="Groups*"
                    sublabel="(minimum of 1)"
                    name="groupIds"
                ></app-form-multiple-select>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "ImportProfileForm",
    props: {
        form: {
            required: true
        },
        includeGroups: {
            default: false
        },
        groups: {
            default: null
        },
        organizationPreferences: {
            required: true
        },
    },
    computed: {
        today() {
            return moment().format('YYYY-MM-DD')
        }
    }
}
</script>

<style scoped>
.profile-create-form-section-title {
    font-weight: 600;
    font-size: 18px;
    margin: 20px 0;
}

.profile-input-field {
    margin: 5px 0
}
</style>